import type { AccountSubscription } from '@common/types';

export const ACCOUNT_SUBSCRIPTION_SEED: AccountSubscription = {
  accountId: 'acc-1',
  tierKey: 'core',
  status: 'active',
  startedAtIso: '2025-04-01T00:00:00.000Z',
  renewsAtIso: '2026-07-01T00:00:00.000Z',
  seatsUsed: 18,
  usage: {
    seats: 18,
    'monthly-reviews': 3120,
    'ai-credits': 1840,
    'connected-sources': 7,
  },
};
